document.addEventListener('DOMContentLoaded', () => {
    const parentElements = document.querySelectorAll('.mainmenu-child--first');

    parentElements.forEach(parentElement => {
        const childElements = parentElement.querySelectorAll('.mainmenu-child--second');

        const childObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const visibleChildHeight = entry.target.offsetHeight;

                    if (visibleChildHeight > parentElement.offsetHeight && visibleChildHeight > parentElement.style.height) {
                        parentElement.style.height = `${visibleChildHeight}px`;
                    }

                    childObserver.disconnect();
                }
            });
        });

        childElements.forEach(childElement => {
            childObserver.observe(childElement);
        });
    });
});
